/** The team list projection; personal rows omit it. */
export interface ItemRowStatus {
  readonly assignment: { readonly handoverId: string; readonly toAccountId: string; readonly requestedBy: string } | null;
  readonly review: { readonly reviewId: string; readonly reviewerAccountId: string; readonly requestedBy: string; readonly stale: boolean } | null;
}
export interface TaskWaiting {
  readonly reason: string;
  readonly since: string;
  readonly by: string;
}
export interface RowStatusItem {
  readonly accountId?: string;
  readonly rowStatus?: ItemRowStatus | null;
}
export function rowStatusMark(row: RowStatusItem): 'Review' | 'Assignment' | null {
  return row.rowStatus?.review ? 'Review' : row.rowStatus?.assignment ? 'Assignment' : null;
}
